// extracted by mini-css-extract-plugin
module.exports = {"header":"Detail_header__yoGI","content":"Detail_content_pYUzU","actions":"Detail_actions_bOAIA"};